import { render, staticRenderFns } from "./Enemies.vue?vue&type=template&id=6742d5ab&"
import script from "./Enemies.vue?vue&type=script&lang=js&"
export * from "./Enemies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports